const deliverPrintTicketsScreenRegex = /^\/deliver-ticket\/[^\/]+\/[^\/]+$/;
const checkDeliverPrintTickets = () => {
  const location = window.location;
  const query = new URLSearchParams(location.search);
  const pathname = location.pathname;
  const fromEmail = query.get('fromEmail');
  const accessDeliverPrintTicketFromEmailLink =
    deliverPrintTicketsScreenRegex.test(pathname) && fromEmail === '1';

  return {
    accessDeliverPrintTicketFromEmailLink,
  };
};

export default checkDeliverPrintTickets;
